import React, { useEffect, useRef, useState } from 'react';
import { Divider, Table, Popconfirm, Card, Tooltip, Switch, Input, Button, Tag, Row, Col, Drawer, Modal, Form, Select } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, RightSquareOutlined, EyeOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import { ColumnProps } from 'antd/lib/table';
import Highlighter from 'react-highlight-words';
import { Link } from 'react-router-dom';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import './excess-inventory-report.css';
import { StockService } from '@gtpl/shared-services/procurement';
import form from 'antd/lib/form';
import { EmployeeRolesEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { Excel } from 'antd-table-saveas-excel';
import { FGStockService} from '@gtpl/shared-services/warehouse-management';
import { UnitcodeService } from '@gtpl/shared-services/masters';
import { PlantsDropDown } from '@gtpl/shared-models/masters';




/* eslint-disable-next-line */
export interface ExcessInventoryReportProps { }

export function ExcessInventoryReport(props: ExcessInventoryReportProps) {
    const [searchText, setSearchText] = useState('');
    const [form] = Form.useForm();
    const [data, setData] = useState<any>();
    const [open, setOpen] = useState(false);
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const [page, setPage] = React.useState(1);
    const [showpopup, setShowpopup] = useState<boolean>(false);
    const [excessiveReportData, setexcessiveReportData] = useState<any[]>([]);
    const service = new StockService();
    const { Option } = Select;
    const [plantData, setPlantData] = useState<PlantsDropDown[]>([]);
    const unitsService = new UnitcodeService();
    

  const storedRole = localStorage.getItem('role')?.replace(/['"]+/g, ''); // Remove any quotes
   const role = EmployeeRolesEnum.ADMIN;
   console.log(storedRole === role, "Match check"); //





    /**
   * used for column filter
   * @param dataIndex column data index
   */
    const getColumnSearchProps = (dataIndex: string) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon={<SearchOutlined />}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Get Report
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase())
                : false,
        onFilterDropdownVisibleChange: visible => {
            if (visible) { setTimeout(() => searchInput.current.select()); }
        },
        render: text =>
            text ? (
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text.toString()}
                    />
                ) : text
            )
                : null

    });
    /**
     * 
     * @param selectedKeys 
     * @param confirm 
     * @param dataIndex 
     */
    function handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    function handleReset(clearFilters) {
        clearFilters();
        setSearchText('');
    };
    useEffect(() => {
        getExcessInventoryReport();
        getAllPlants()
        if (storedRole !== EmployeeRolesEnum.ADMIN) {
            form.setFieldsValue({ unitId: Number(localStorage.getItem('unit_id')) })
          }
    }, [])

    const handleCancel = () => {
        setShowpopup(false)
    };

    const handleOk = () => {
        setShowpopup(false)
    }

    const handlesubmit = () => {
        setShowpopup(false);
    }


    const getExcessInventoryReport = () => {
        // const req = new UnitRequest(Number(localStorage.getItem('unit_id')))
        const req = new UnitRequest(form.getFieldValue("unitId") ? form.getFieldValue("unitId") : Number(localStorage.getItem('unit_id')) )

        service.getExcessInventoryReport(req).then(res => {
            if (res.status) {
                setexcessiveReportData(res.data);
            } else {
                
              setexcessiveReportData([]);
              AlertMessages.getErrorMessage(res.internalMessage);
               
            }
        }).catch(err => {
            AlertMessages.getErrorMessage(err.message);
            setexcessiveReportData([]);
        })
    }

    const getAllPlants = () => {
        unitsService.getAllMainPlants().then((res) => {
          if (res.status) {
            setPlantData(res.data);
          } else {
            setPlantData([]);
          }
        }).catch(err => {
          AlertMessages.getErrorMessage(err.message);
          setPlantData([]);
        })
      }
    
      const handleFormReset = () => {
        form.resetFields(); 
        getExcessInventoryReport(); 
        if (storedRole !== EmployeeRolesEnum.ADMIN) {
          form.setFieldsValue({ unitId: Number(localStorage.getItem('unit_id')) })
        }
      }

    const excelcolumns = [
        {
            title: 'Unit',
            dataIndex: 'unitName',
        },
        {
            title: 'Item Name',
            dataIndex: 'itemName',
        },
        {
            title: 'Inventory Stock',
            dataIndex: 'physicalQty',
        },
        {
            title: 'Bom Required',
            dataIndex: 'requiredQty',
        },
        {
            title: 'Excess Qty',
            dataIndex: 'excessQty',
        },
        
      ];

    const exportExcel=()=>{
        const excel = new Excel();
              excel
                .addSheet('StoreConsumptionReport')
                .addColumns(excelcolumns)
                .addDataSource(excessiveReportData)
                .saveAs('StoreConsumptionReport.xlsx');
        }

    const columnDatailView: ColumnProps<any>[] = [
        {
            title: 'SO Number',
            dataIndex: 'soNumber',
            width: '100px'
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            width: '100px'
        },
    ]

    const columnsSkelton: ColumnProps<any>[] = [
        {
            title: '#Sno',
            key: 'sno',
            width: '30px',
            responsive: ['sm'],
            render: (text, object, index) => (page - 1) * 10 + (index + 1)
        },
        {
            title: 'Unit',
            dataIndex: 'unitName',
            width: '400px'
        },
        {
            title: 'Item Name',
            dataIndex: 'itemName',
            width: '400px',
            ...getColumnSearchProps('itemName')
            // responsive: ['lg'],
        },
        //   {
        //       title: 'PO wise allocated Qty',
        //       dataIndex: 'stockAllocated',  
        //      width:'800px',
        //   },
        {
            title: 'Inventory Stock',
            dataIndex: 'physicalQty',
             width: '200px',
            align:'right',
            sorter: (a, b) => a.physicalQty - b.physicalQty,
            sortDirections: ['descend', 'ascend'],
           render: (text) => parseFloat(text),


        },
        {
            title: 'Bom Required',
            dataIndex: 'requiredQty',
             width: '200px',
            align:'right',
            sorter: (a, b) => a.requiredQty - b.requiredQty,
            sortDirections: ['descend', 'ascend'],
           render: (text) => parseFloat(text),

        },
        {
            title: 'Excess Qty',
            dataIndex: 'excessQty',
            width: '200px',
            align:'right',
            sorter: (a, b) => a.excessQty - b.excessQty,
            sortDirections: ['descend', 'ascend'],
          render: (text) => parseFloat(text),

        },
        // {
        //     title: 'Action',
        //     render: (rowData) => (
        //         <span>
                    
        //             <Button icon={<EyeOutlined />} type="primary" shape="round" size="small" onClick={() => {
        //                 setData(rowData)
        //                 //   alert();
        //                 setShowpopup(true)
        //             }} />
        //         </span>
        //     )
        // },

    ];
    return (
        <>
            <Card title={<span style={{ color: 'white' }}>Excess inventory Report</span>}
            extra={<Button onClick={() => {exportExcel();}}>Get Excel</Button>}
                style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}>
                    <Form form={form} layout={'vertical'} style={{ padding: '0px' }} >
                    {/* <Form.Item
                    style={{ display: "none" }}
                    name="plantId" initialValue={Number(localStorage.getItem('unit_id'))}>
                    <Input hidden />
                    </Form.Item> */}
                    <Row gutter={[24, 24]}>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6}}>
            <Form.Item
              name="unitId"
              label=" Unit"
              rules={[
                {
                  required: false, message: 'Select Unit',
                },
              ]}
            >
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select Unit"
                allowClear
                disabled={storedRole === EmployeeRolesEnum.ADMIN ? false : true}
                dropdownMatchSelectWidth={false}
                style={{ width: '100%' }}
              >
                {plantData.map(dropData => {
                  return <Option value={dropData.plantId}>{dropData.plantCode}</Option>
                })}
              </Select>
            </Form.Item>

          </Col>
          
        
          

          <Col style={{ marginTop: 30 }} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 2 }} lg={{ span: 2 }} xl={{ span: 2 }}  >
            <Button
              type="primary"
              // icon={<SearchOutlined />}
              onClick={getExcessInventoryReport}
            >
              Search
            </Button>
          </Col>
          <Col span={2} style={{ paddingTop: '30px' }}>
            <Button type="primary" htmlType="submit" onClick={handleFormReset} style={{ marginLeft: 1 }} >
              Reset
            </Button>
           
          </Col>
        </Row>

                    </Form>

    
         { excessiveReportData.length > 0 ?
                <>
             

            <Table 
                rowKey={record => record.downtimeTrackingId}
                columns={columnsSkelton}
                dataSource={excessiveReportData}
                scroll={{ x: 1000 }}
                pagination={{
                    onChange(current, pageSize) {
                        setPage(current);
                    }
                }}
                // onChange={onChange}
                size='small'
                bordered />

      </> : ''}     
            <Modal
                onOk={handleOk}
                onCancel={handleCancel}
                key={Date.now()}
                visible={showpopup}
                width={'40%'}
                style={{ top: 30, alignContent: 'right' }}
            >
                <Card title={<span style={{ color: 'white' }}>Detail View</span>}
                    style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}></Card>
                <Table
                    columns={columnDatailView}
                >
                </Table>
            </Modal>
            </Card>
        </>

    );
}

export default ExcessInventoryReport;
